import React, { useEffect } from "react";
import { SidePanel } from "./side-panel";
import Transactions from "./transactions";
import { MixpanelEvent, trackEvent } from "../../analytics/mixpanel";

const Wallet = () => {
  const isPageViewTracked = React.useRef(false);

  useEffect(() => {
    if (isPageViewTracked.current) return;
    trackEvent(MixpanelEvent.PAGE_VIEW, { page_name: "wallet" });
    isPageViewTracked.current = true;
  }, []);
  return (
    <div className="min-h-screen w-screen md:bg-gray-100 bg-[#ebebeb]">
      <div className="flex md:flex-row md:justify-center flex-col-reverse gap-8">
        <div className="md:w-1/2 md:pt-6">
          <Transactions />
        </div>
        <div className="bg-white md:bg-transparent pt-6 md:sticky md:top-20 md:h-fit">
          <SidePanel />
        </div>
      </div>
    </div>
  );
};

export default Wallet;
